<template>
  <button 
    type="button" 
    class="btn btn-vigo-weiter rounded-pill d-flex align-items-center justify-content-center gap-2"
    data-shake
    :disabled="disabled"
  >
    <span class="btn-text">weiter</span>
    <svg 
      class="chevron-icon" 
      width="20" 
      height="21" 
      viewBox="0 0 20 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.5 4.25L13.75 10.5L7.5 16.75" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script setup>
// Weiter-Button Komponente basierend auf Figma Design
defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.btn-vigo-weiter {
  background-color: var(--vigo-1-500-bg);
  color: var(--vigo-hell-text);
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  padding: 12px 24px;
  border: none;
  transition: background-color 0.2s ease;
}

.btn-vigo-weiter:hover {
  background-color: var(--vigo-1-600-bg);
  color: var(--vigo-hell-text);
}

.btn-vigo-weiter:active {
  background-color: var(--vigo-1-600-bg);
}

.btn-vigo-weiter:disabled {
  background-color: #cccccc;
  color: #666666;
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-vigo-weiter:disabled:hover {
  background-color: #cccccc;
  color: #666666;
}

.btn-text {
  white-space: nowrap;
}

.chevron-icon {
  width: 20px;
  height: 21px;
  flex-shrink: 0;
}
</style>
